import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const PaymentDiscount7 = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        width: "100%",
        p: 1,
        my: 1,
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50px",
        border: "1px dashed #3ebf90",
      }}
    >
      <Typography
        fontSize="14px"
        lineHeight="18px"
        fontWeight={600}
        color="#3ebf90"
      >
        {t("checkout.v7.payments.discountBadge")}
      </Typography>
    </Box>
  )
}

export default PaymentDiscount7
